import React from "react"
import { Link } from "gatsby"
import ComposeLink from "../helpers/product_link"

const ProductCard = ( { product }) => {
    console.log(product);    
    return(
        <div className="col-md-3 mb-30" item-code={ product.item_code }>
            <Link to={ ComposeLink( product ) } className="text-decoration-none">
                <div className="card w-100 product-card">
                    <img className="card-img-top" src={ product.card_image_main } alt={ product.item_description } />
                    <div className="card-body">
                        <p className="card-text">
                            { product.brand } { product.recipe }
                        </p>
                        <small className="text-red">
                            { product.item_description }
                        </small>
                    </div>
                </div>
                {/* <img src={product.card_image_main} alt="Logo" /> */}
            </Link>
        </div>
    )
}

export default ProductCard